import {
  Box, CircularProgress, Tab
} from "@material-ui/core";
import { TabContext, TabList } from "@material-ui/lab";
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import {
  deactivateSavedQuery,
  deleteSavedQuery,
  getSavedQueries,
  processSavedQuery,
  updateSavedQuery,
} from "../Apis/QueryApi";
import { getUserData } from "../Apis/UserApi";
import AddForSellModal from "./Modals/AddForSellModal";
import CreateQueryModal from "./Modals/CreateQueryModal";
import EditQueryModal from "./Modals/EditQueryModal";
import ImportQueryModal from "./Modals/ImportQueryModal";
import Navbar from "./Navbar";
import QueriesTable from "./QueriesTable";
import RemoveFromSellModal from "./Modals/RemoveFromSellModal";
import DeleteSelectedQueriesModal from "./Modals/DeleteSelectedQueriesModal";
import {
  SAVED_QUERY_MARKET_OPTIONS,
  UNDEFINED_MARKET_FILTER_VALUE,
  isSavedQueryMarketValue,
} from "../constants/savedQueryMarkets";


export const LoaderCont = styled("div")`
  display: grid;
  place-items: center;
  margin-top: 50px;
`;

function clampRank1to5(v) {
  if (v == null || v === "") {
    return 1;
  }
  const n = typeof v === "number" ? v : parseInt(String(v).trim(), 10);
  if (Number.isNaN(n)) {
    return 1;
  }
  return Math.min(5, Math.max(1, n));
}

const SavedQueriesPage = (props) => {
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);

  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openCreateModal, setOpenCreateModal] = React.useState(false);
  const [openImportModal, setOpenImportModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [canSell, setCanSell] = React.useState(false);


  const handleQueryImportOpen = () => setOpenImportModal(true);
  const handleQueryImportClose = () => setOpenImportModal(true);
  const handleOpen = () => setOpenCreateModal(true);
  const handleClose = () => setOpenCreateModal(false);

  const [queriesData, setQueriesData] = React.useState([]);
  const [filteredQueriesData, setFilteredQueriesData] = React.useState([]);
  const [showActiveQueriesState, setShowActiveQueriesState] = React.useState(false);
  const [currentEditQuery, setCurrentEditQuery] = React.useState({});
  const [tabValue, setTabValue] = React.useState("NFL");
  const [selectedQueries, setSelectedQueries] = React.useState([]);

  const [openMonetizeModal, setOpenMonetizeModal] = React.useState(false);
  const [openRemoveFromSellModal, setOpenRemoveFromSellModal] = React.useState(false);
  const [currentMonetizeQuery, setCurrentMonetizeQuery] = React.useState({});
  const [loadError, setLoadError] = React.useState(null);
  const [filterMarket, setFilterMarket] = React.useState("");
  const [filterRank, setFilterRank] = React.useState("");

  const baseQueriesForTable = showActiveQueriesState
    ? filteredQueriesData
    : queriesData;

  const tableRows = useMemo(() => {
    return baseQueriesForTable.filter((q) => {
      if (filterMarket) {
        if (filterMarket === UNDEFINED_MARKET_FILTER_VALUE) {
          if (isSavedQueryMarketValue(q.market)) {
            return false;
          }
        } else if (q.market !== filterMarket) {
          return false;
        }
      }
      if (filterRank) {
        const want = parseInt(filterRank, 10);
        if (!Number.isNaN(want) && clampRank1to5(q.sort_order) !== want) {
          return false;
        }
      }
      return true;
    });
  }, [baseQueriesForTable, filterMarket, filterRank]);

  const handleQuerySelect = (queryId, remove) => {
    if (!remove) {
      setSelectedQueries([...new Set([...selectedQueries, queryId])]);
    } else {
      const newSelectedQueries = selectedQueries.filter(
        (val) => val !== queryId
      );
      setSelectedQueries([...new Set([...newSelectedQueries])]);
    }
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const fetchData = async () => {
    setLoading(true);
    setLoadError(null);
    const r = await getSavedQueries(tabValue);
    console.log(r);
    if (r.ok) {
      setQueriesData(r.data);
    } else {
      setQueriesData([]);
      const e = r.error;
      setLoadError(
        e
          ? `${e.message} Request URL: ${e.requestUrl || ""}`.trim()
          : "Could not load saved queries."
      );
    }
    setLoading(false);
  };

  const fetchUserData = async () => {
    const data = await getUserData();
    if (data) {
      console.log(data)
      setCanSell(data?.can_sell);
    }
  };

  const handleDeleteModal = () => {
    setOpenDeleteModal(!openDeleteModal)
  };

  const handleEditOpen = (queryId) => {
    const currentQuery = queriesData.filter((query) => query.id === queryId)[0];
    if (currentQuery) {
      setCurrentEditQuery(currentQuery);
      console.log(currentQuery);
      setOpenEditModal(true);
    }
  };

  const handleSortOrderChange = async (query, rawValue) => {
    const n = parseInt(String(rawValue).trim(), 10);
    if (Number.isNaN(n)) {
      return;
    }
    const next = Math.min(5, Math.max(1, n));
    const currentRaw = query.sort_order != null ? query.sort_order : 1;
    if (next === currentRaw) {
      return;
    }
    const patchSortOrder = (list) =>
      list.map((q) => (q.id === query.id ? { ...q, sort_order: next } : q));
    setQueriesData((prev) => patchSortOrder(prev));
    if (showActiveQueriesState) {
      setFilteredQueriesData((prev) => patchSortOrder(prev));
    }
    setLoading(true);
    const res = await updateSavedQuery({ sort_order: next }, query.id);
    if (res) {
      const g = await getSavedQueries(tabValue);
      if (g.ok) {
        setQueriesData(g.data);
        if (showActiveQueriesState) {
          setFilteredQueriesData(
            g.data.filter(
              ({ next_active_date }) =>
                new Date(new Date(Number(next_active_date) * 1000).toDateString()) >=
                new Date(new Date().toDateString())
            )
          );
        }
      }
    } else {
      await fetchData();
    }
    setLoading(false);
  };

  const handleMarketChange = async (query, nextMarket) => {
    const current = isSavedQueryMarketValue(query?.market)
      ? query.market
      : null;
    const next =
      nextMarket === "" || nextMarket === undefined ? null : nextMarket;
    if (next === current) {
      return;
    }
    const patchMarket = (list) =>
      list.map((q) => (q.id === query.id ? { ...q, market: next } : q));
    setQueriesData((prev) => patchMarket(prev));
    if (showActiveQueriesState) {
      setFilteredQueriesData((prev) => patchMarket(prev));
    }
    setLoading(true);
    const res = await updateSavedQuery({ market: next }, query.id);
    if (res) {
      const g = await getSavedQueries(tabValue);
      if (g.ok) {
        setQueriesData(g.data);
        if (showActiveQueriesState) {
          setFilteredQueriesData(
            g.data.filter(
              ({ next_active_date }) =>
                new Date(new Date(Number(next_active_date) * 1000).toDateString()) >=
                new Date(new Date().toDateString())
            )
          );
        }
      }
    } else {
      await fetchData();
    }
    setLoading(false);
  };

  const handleMonetizeOpen = (queryId) => {
    if (!canSell) return;
    const currentQuery = queriesData.filter((query) => query.id === queryId)[0];
    if (currentQuery) {
      setCurrentMonetizeQuery(currentQuery);
      setOpenMonetizeModal(true);
    }
  };

  const handleRemoveFromSellOpen = (queryId) => {
    const currentQuery = queriesData.filter((query) => query.id === queryId)[0];
    if (currentQuery) {
      setCurrentMonetizeQuery(currentQuery);
      setOpenRemoveFromSellModal(true);
    }
  };

  const handleProcessQuery = async () => {
    if (selectedQueries.length <= 0) return;
    setLoading(true)
    await processSavedQuery({ data: selectedQueries });
    await fetchData();
    setSelectedQueries([]);
    setLoading(false)
  };

  const handleDeactivateQuery = async () => {
    if (selectedQueries.length <= 0) return;
    setLoading(true)
    await deactivateSavedQuery({ data: selectedQueries });
    await fetchData();
    setSelectedQueries([]);
    setLoading(false)
  };

  const handleShowActiveQueries = () => {
    const filteredData = queriesData.filter(({ next_active_date }) => new Date(new Date(Number(next_active_date) * 1000).toDateString()) >= new Date(new Date().toDateString())); 
    setFilteredQueriesData(filteredData)
    setShowActiveQueriesState(!showActiveQueriesState);
  };

  useEffect(() => {
    setQueriesData([]);
    setLoadError(null);
    setSelectedQueries([]);
    setShowActiveQueriesState(false);
    setFilteredQueriesData([]);
    setFilterMarket("");
    setFilterRank("");
    fetchData();
  }, [tabValue]);

  useEffect(() => {
    if (!props.store.isAuthenticated) {
      history.replace("/login")
    }
    fetchUserData();
  }, []);

  return (
    <>
      <Navbar />
      <div style={{ marginTop: "120px" }}>
        <div className="d-flex mx-4">
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleOpen()}
          >
            Add New SDQL
          </button>
          <button
            className="btn btn-danger btn-sm ms-3"
            onClick={() => handleQueryImportOpen()}
          >Import SDQLs</button>
          <button
            className="btn btn-success btn-sm ms-3"
            onClick={() => handleProcessQuery()}
            disabled={loading || selectedQueries.length <= 0 ? true : false}
          >Start SDQLs</button>
          {selectedQueries.length > 0 && (
            <button
              className="btn btn-danger btn-sm ms-3"
              onClick={() => handleDeactivateQuery()}
              disabled={loading || selectedQueries.length <= 0 ? true : false}
            >Deactivate SDQLs</button>
          )}
          <button
            className="btn btn-primary btn-sm ms-3"
            onClick={() => handleShowActiveQueries()}
          >
            {showActiveQueriesState ? "Show all queries" : "Show Today's Active Queries"}
          </button>
        </div>
        {loadError && (
          <div
            className="alert alert-warning mx-4 mt-2"
            role="alert"
          >
            {loadError}
          </div>
        )}

        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", maxWidth: "100vw" }}>
            <TabList onChange={handleChange} variant="scrollable">
              <Tab label="NFL" value="NFL" />
              <Tab label="NCAAFB" value="NCAAFB" />
              <Tab label="NBA" value="NBA" />
              <Tab label="MLB" value="MLB" />
              <Tab label="NHL" value="NHL" />
              <Tab label="NCAABB" value="NCAABB" />
              <Tab label="CFL" value="CFL" />
              <Tab label="WNBA" value="WNBA" />
              <Tab label="UFC" value="UFC" />
              <Tab label="UFCW" value="UFCW" />
              <Tab label="ATP" value="ATP" />
              <Tab label="NFLPRE" value="NFLPRE" />
            </TabList>
          </Box>
          <Box
            sx={{
              margin: "30px auto",
              maxWidth: "1600px",
              padding: "0px 20px",
            }}
          >
            <div className="mb-3 text-end">
              {selectedQueries.length > 0 && (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDeleteModal()}
                  disabled={loading}
                >
                  Delete Selected SDQLs
                </button>
              )}
            </div>

            {!loading && (
              <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                <label htmlFor="saved-filter-market" className="mb-0 text-nowrap">
                  Market
                </label>
                <select
                  id="saved-filter-market"
                  className="form-select form-select-sm"
                  style={{ width: "auto", minWidth: 140 }}
                  value={filterMarket}
                  onChange={(e) => setFilterMarket(e.target.value)}
                >
                  <option value="">All</option>
                  <option value={UNDEFINED_MARKET_FILTER_VALUE}>
                    Undefined
                  </option>
                  {SAVED_QUERY_MARKET_OPTIONS.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
                <label htmlFor="saved-filter-rank" className="mb-0 ms-2 text-nowrap">
                  Rank
                </label>
                <select
                  id="saved-filter-rank"
                  className="form-select form-select-sm"
                  style={{ width: "auto", minWidth: 88 }}
                  value={filterRank}
                  onChange={(e) => setFilterRank(e.target.value)}
                >
                  <option value="">All</option>
                  {[1, 2, 3, 4, 5].map((n) => (
                    <option key={n} value={String(n)}>
                      {n}
                    </option>
                  ))}
                </select>
                {(filterMarket || filterRank) && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => {
                      setFilterMarket("");
                      setFilterRank("");
                    }}
                  >
                    Clear filters
                  </button>
                )}
                {(filterMarket || filterRank) && baseQueriesForTable.length > 0 && (
                  <span className="text-muted small ms-1">
                    Showing {tableRows.length} of {baseQueriesForTable.length}
                  </span>
                )}
              </div>
            )}

            {loading ? (
              <LoaderCont>
                <CircularProgress />
              </LoaderCont>
            ) : (
              <>
              {!loading &&
                showActiveQueriesState &&
                queriesData.length > 0 &&
                filteredQueriesData.length === 0 && (
                <p className="text-muted small mb-2" role="status">
                  You are viewing <strong>Today&apos;s active queries</strong> only, and none match.{" "}
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0 align-baseline"
                    onClick={() => handleShowActiveQueries()}
                  >
                    Show all queries
                  </button>{" "}
                  for {tabValue}.
                </p>
              )}
              {!loading &&
                tableRows.length === 0 &&
                baseQueriesForTable.length > 0 &&
                (filterMarket || filterRank) && (
                  <p className="text-muted small mb-2" role="status">
                    No queries match the selected market and rank. Try{" "}
                    <button
                      type="button"
                      className="btn btn-link btn-sm p-0 align-baseline"
                      onClick={() => {
                        setFilterMarket("");
                        setFilterRank("");
                      }}
                    >
                      clearing filters
                    </button>
                    .
                  </p>
                )}
              <QueriesTable
                data={tableRows}
                tabValue={tabValue}
                handleQuerySelect={handleQuerySelect}
                handleEditOpen={handleEditOpen}
                handleMonetizeOpen={handleMonetizeOpen}
                handleRemoveFromSellOpen={handleRemoveFromSellOpen}
                handleSortOrderChange={handleSortOrderChange}
                handleMarketChange={handleMarketChange}
                canSell={canSell}
              />
              </>
            )}
          </Box>
        </TabContext>
      </div>

      <DeleteSelectedQueriesModal
        fetchData={fetchData}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        selectedQueries={selectedQueries}
      />

      <CreateQueryModal
        fetchData={fetchData}
        open={openCreateModal}
        setOpen={setOpenCreateModal}
        tabValue={tabValue}
      />

      <ImportQueryModal
        fetchData={fetchData}
        open={openImportModal}
        setOpen={setOpenImportModal}
      />

      <EditQueryModal
        fetchData={fetchData}
        open={openEditModal}
        setOpen={setOpenEditModal}
        currentEditQuery={currentEditQuery}
        setCurrentEditQuery={setCurrentEditQuery}
      />

      <AddForSellModal
        fetchData={fetchData}
        open={openMonetizeModal}
        setOpen={setOpenMonetizeModal}
        currentMonetizeQuery={currentMonetizeQuery}
        setCurrentMonetizeQuery={setCurrentMonetizeQuery}
      />

      <RemoveFromSellModal
        fetchData={fetchData}
        open={openRemoveFromSellModal}
        setOpen={setOpenRemoveFromSellModal}
        currentMonetizeQuery={currentMonetizeQuery}
        setCurrentMonetizeQuery={setCurrentMonetizeQuery}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state,
  };
};

const mapDispatchToProps = (dispatch) => {
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedQueriesPage);
